import { Injectable } from '@angular/core';
import { HttpParams, HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { environment } from '../../environments/environment';
//import { isObject } from 'util';


@Injectable()
export class AppService {
  account:any;
  basePath:string;
  version:number;
  apiUrl:any;
  api:any;
  str_version:string;
  
  constructor(private http:HttpClient,private router:Router,) { 
    //this.apiUrl = 'http://localhost:5000/ledube-fd494/us-central1';
    
    this.apiUrl = environment.api;
    this.api = {
      connect:'/screenConnect',
      get:'/screenGet',
      online:'/clientOnline',
      streaming:'/clientStream',
      snapshot:'/screenSnapshot',
      ad_snapshot:'/auditSnapshot',
      countview:'/screenRegisterAdViews',
      
    };
    this.version = 2.0;
    this.str_version = "2.0.0";
  }

  getVersionStr(){
    return this.str_version;
  }

  getVersion(){
      return this.version;
  }

  getApiUrl(){
      return this.apiUrl;
  }

  getApi(){
    return this.api;
  }

  getMachineId():any{
    let mid = localStorage.getItem('MACHINE_ID');
    if(!mid || mid == null || mid == 'null'){
        mid = this.generateMID();
        localStorage.setItem('MACHINE_ID',mid);
    }
    return mid;
  }

  getName(){
    let mid = this.getMachineId();
    let name = localStorage.getItem(mid+'-Name');
    return name;
  }

  private generateMID():any{
    let mid = Math.round(new Date().getTime() / 1000);
    return mid;
  }

  isConnected(screen_id = null){
      let data = this.getConnectData(screen_id);

      if(data != null && typeof(data)!= null && data != '' && typeof(data.token) != 'undefined'){
          return true;
      }
      return false;

  }

  connectScreen(code,name,fn){
    //R4J4F2
    let mid = this.getMachineId();
    let response:any;

    let params = new HttpParams();
    params = params.append('code', code);
    params = params.append('name', name);
    params = params.append('session_id',mid);

    localStorage.setItem(mid+'-Name',name);

    let call = this.http.get<ApiData>(this.apiUrl+this.api.connect,{params: params});
    call.subscribe(data=>{
        if(data.status == 'OK'){
            data.data.client_name = name;
            this.saveConnectData(data.data);
        }
        fn(data);
    },(error)=>{
        fn({staus:'ERROR',message:'No internet connection'});
    });
  }

  saveConnectData(data):void{
    let mid = this.getMachineId();
    localStorage.setItem(mid+'-ConnectData-'+data.screen_id,JSON.stringify(data));
    localStorage.setItem(mid+'-LastScreenId',data.screen_id);
    this.addScreen(data);
  }

  addScreen(sc){
    let mid = this.getMachineId();
    let json = localStorage.getItem(mid+'-Screens');
    if(!json || json == '' || json == null){
      json = "[]";
    }
    let data = JSON.parse(json);
    data.push({ name:sc.screen_name,id:sc.screen_id});

    localStorage.setItem(mid+'-Screens',JSON.stringify(data));

  }

  

  getLastScreenId(){
    let mid = this.getMachineId();
    let screen_id = localStorage.getItem(mid+'-LastScreenId');
    if(screen_id){
      return screen_id;
    }else{
      return null;
    }
  }

  getConnectData(screen_id = null):any{
    if(screen_id == null){
      screen_id = this.getLastScreenId();
    }
    if(screen_id == null){
      return false;
    }

    let mid = this.getMachineId();
    let json = localStorage.getItem(mid+'-ConnectData-'+screen_id);
    if(!json || json == '' || json == null){
        return false;
    }
    
    let data = JSON.parse(json);

    if(data == null && typeof(data)== null && data == '' && typeof(data.token) == 'undefined'){
      return false;
    }
    localStorage.setItem(mid+'-LastScreenId',screen_id);
    return data;

  }

  removeScreen(screen_id){
    let mid = this.getMachineId();
    let screens = this.getScreens();
    let new_screens = [];

    //clean cache
    localStorage.setItem(screen_id+'-BillboCurrentSchedule','');
    localStorage.setItem(screen_id+'-BillboCurrentPlaylist','');
    localStorage.setItem(screen_id+'-BillboCurrentResources','');
    localStorage.setItem(mid+'-AdCountQueue-'+screen_id,'[]');
    
    screens.forEach(s => {
      if(s.id != screen_id){
        new_screens.push(s);
      }
    });
    localStorage.setItem(mid+'-Screens',JSON.stringify(new_screens));
    return true;
  }

  checkScreen(sid){
    let screens = this.getScreens();
    let check = false;
    screens.forEach(s=>{
      if(s.id == sid){
        check = true;
      }
    })
    return check;
  }

  getScreens(){
    let mid = this.getMachineId();
    let json = localStorage.getItem(mid+'-Screens');
    
    if(!json || json == '' || json == null || json == '' ){
      json = "[]";
    }
    let data = JSON.parse(json);
    return data;
  }

  exitScreen(screen_id):void{
    let mid = this.getMachineId();
    localStorage.setItem(mid+'-LastScreenId','');
    localStorage.setItem(mid+'-Audit-'+screen_id,'[]');
    this.router.navigate(['0']);
    
  }


}


export interface ApiData{
    data:any
    status:any,
    message:any,
    v:any,
}


// WEBPACK FOOTER //
// /Users/andrescufari/Angular/billbo-desktop-v2/src/app/services/app.service.ts